<div *ngIf="dataLength === 0" class="text-align-center pt-10 pb-10 fw-bold">
  No Records Found
</div>
